import type { PoSchedule, PurchaseOrder, ScheduleMark, ToScheduleQueue } from '@/types/purchaseOrders';
import apiClient from './axios';

interface PurchaseOrderListResponse {
  data: PurchaseOrder[];
}

export interface PurchaseOrderQuery {
  // Omitted = search across all vendors; the backend then requires a search term.
  vendorId?: string;
  states: string[];
  search?: string;
  // Capacity type id; the backend then excludes POs with nothing left for that type.
  schedulableForType?: string;
}

export async function fetchPurchaseOrders(query: PurchaseOrderQuery): Promise<PurchaseOrder[]> {
  const { data } = await apiClient.get<PurchaseOrderListResponse>('/purchase-orders', {
    params: {
      vendorId: query.vendorId || undefined,
      states: query.states.join(','),
      search: query.search?.trim() || undefined,
      schedulableForType: query.schedulableForType || undefined,
    },
    skipGlobalError: true,
  });
  return data.data;
}

export async function fetchPoSchedule(poNumber: string): Promise<PoSchedule> {
  const { data } = await apiClient.get<PoSchedule>(`/purchase-orders/${encodeURIComponent(poNumber)}/schedule`, { skipGlobalError: true });
  return data;
}

export async function markPoScheduled(poNumber: string, vendorId: string, note: string | null): Promise<ScheduleMark> {
  const { data } = await apiClient.put<ScheduleMark>(`/purchase-orders/${encodeURIComponent(poNumber)}/schedule-mark`, { vendorId, note }, { skipGlobalError: true });
  return data;
}

export async function unmarkPoScheduled(poNumber: string, vendorId: string): Promise<void> {
  await apiClient.delete(`/purchase-orders/${encodeURIComponent(poNumber)}/schedule-mark`, { params: { vendorId }, skipGlobalError: true });
}

export async function fetchToScheduleQueue(vendorId: string, options: { refresh?: boolean } = {}): Promise<ToScheduleQueue> {
  const { data } = await apiClient.get<ToScheduleQueue>('/purchase-orders/to-schedule', {
    params: { vendorId, refresh: options.refresh ? 'true' : undefined },
    skipGlobalError: true,
  });
  return data;
}
